// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__7QZ-7","modal":"Modal_modal__nyz+P","slide-down":"Modal_slide-down__7C0YN"};